import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const KRBusinessConfig = initConst<IBusinessConfigs>(() => ({
  KRKund: {
    defaultColumns: [
      { attributeDef: 'KUNDNR_KONTONR', caption: 'Kundnr/Avtalsnr' },
      { attributeDef: 'OrgPers.Namn', caption: 'Namn' },
      { attributeDef: 'OrgPers.Adress.KompaktAdressRad', caption: 'Adress' },
      // { attributeDef: 'ReskontraSaldoAktInt', caption: 'Saldo reskontra' },
      { attributeDef: 'Kundtyp', caption: 'Typ av kund' },
      { attributeDef: 'KundkategoriKodBen', caption: 'Kundkategori' },
    ],
  },
  KRBetalningsfil: {
    defaultColumns: [
      { attributeDef: 'Fildatum', caption: 'Skapad' },
      { attributeDef: 'Totalbelopp', caption: 'Totalt belopp' },
      { attributeDef: 'AntalBet', caption: 'Transaktioner' },
      { attributeDef: 'Kommunikationsfil.InlastText', caption: 'Inläst' },
      { attributeDef: 'Hanterad_Text', caption: 'Hanterad' },
      { attributeDef: 'Inbetalningsvag.BENAMNING', caption: 'Inbetalningsväg' },
      { attributeDef: 'Kommunikationsfil.NAMN', caption: 'Filnamn' },
    ],
  },
  KRAterrapKundfakt: {
    defaultColumns: [
      { attributeDef: 'Proddatum', caption: 'Skapad' },
      { attributeDef: 'LOPNR_PER_AR', caption: '' },
      { attributeDef: 'Totalbelopp', caption: '' },
      { attributeDef: 'AntalTransaktioner', caption: 'Transaktioner' },
      { attributeDef: 'Hanterad_Text', caption: '' },
      { attributeDef: 'Kommunikationsfil.NAMN', caption: 'Filnamn' },
    ],
  },
  Fakturabetalning: {
    defaultColumns: [
      { attributeDef: 'RegVerDatum', caption: 'Bokf dat' },
      { attributeDef: 'RegVerNr', caption: 'Ver nr' },
      { attributeDef: 'FAKTURA_NR', caption: 'Fakt nr' },
      { attributeDef: 'Fakturabelopp', caption: 'Belopp' },
      { attributeDef: 'FORFALLO_DATUM', caption: 'Förf dat' },
      { attributeDef: 'Kund.KUNDNR_KONTONR', caption: 'Kundnr' },
      { attributeDef: 'NAMN', caption: 'Kundnamn' },
      { attributeDef: 'FAKTURARUBRIK', caption: 'Fakturarubrik' },
      { attributeDef: 'BetKredStatus', caption: 'Sen bet dat' },
      { attributeDef: 'FakturaSaldo', caption: 'Saldo' },
      { attributeDef: 'SaldoPerDatum', caption: 'Saldo per datum' },
      { attributeDef: 'Adress', caption: 'Kundens adress' },
      { attributeDef: 'FAKTURADATUM', caption: 'Fakt dat' },
      {
        attributeDef: 'Faktureringsgrupp.BENAMNING',
        caption: 'Faktureringsgrupp',
      },
      { attributeDef: 'FAKTURERINGSSATT', caption: 'Faktureringssätt' },
      { attributeDef: 'orderTyp', caption: 'Typ av order' },
      { attributeDef: 'Kund.TYP', caption: 'Kundtyp' },
      { attributeDef: 'Kund.KundKategori.BENAMNING', caption: 'Kundkategori' },
    ],
  },
  KRFaktura: {
    defaultColumns: [
      { attributeDef: 'NAMN', caption: 'Kundnamn' },
      { attributeDef: 'Kund.KUNDNR_KONTONR', caption: 'Kundnr' },
      { attributeDef: 'MaxKrav', caption: 'Föreg krav' },
      { attributeDef: 'FAKTURA_NR', caption: 'Fakturanr' },
      { attributeDef: 'FORFALLO_DATUM', caption: 'Förf dat' },
      { attributeDef: 'Fakturabelopp', caption: 'Fakturabelopp' },
      { attributeDef: 'FakturaSaldo', caption: 'Fakturasaldo' },
      {
        attributeDef: 'Betalningsvillkor.BETALNINGSVILLKORKOD',
        caption: 'Bet villk',
      },
    ],
  },
  KRKravOmgang: {
    defaultColumns: [
      { attributeDef: 'KRAVOMGANG_NR', caption: 'Nr' },
      { attributeDef: 'DATUM', caption: 'Datum' },
      { attributeDef: 'TID', caption: 'Tid' },
      { attributeDef: 'SIGNATUR', caption: 'Signatur' },
      { attributeDef: 'AntalKrav', caption: 'Antal krav' },
    ],
  },
  KRBetalningsorder: {
    defaultColumns: [
      { attributeDef: 'REG_DATUM', caption: 'Produktionsdatum' },
      { attributeDef: 'SkapadFil', caption: 'Skapad fil' },
      { attributeDef: 'AUTOGIRO_VAG', caption: 'Skickas till' },
    ],
  },
  KRLicenser: {
    defaultColumns: [{ attributeDef: 'LICENSNUMMER', caption: 'Licensnummer' }],
  },
  KRKundkategori: {
    defaultColumns: [
      { attributeDef: 'KUNDKAT_KOD', caption: 'Kundkategori' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'INTERN', caption: 'Intern' },
      { attributeDef: 'Typben', caption: 'Typ' },
    ],
  },
  KRInbetalningsvag: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'TYP', caption: 'Filtyp' },
      { attributeDef: 'AKTIV', caption: 'Aktiv' },
    ],
  },
  KRKundfakturabunt: {
    defaultColumns: [
      { attributeDef: 'DATUM', caption: 'Datum' },
      { attributeDef: 'LOPNR', caption: 'Löpnr' },
      { attributeDef: 'STATUS', caption: 'Status' },
      {
        attributeDef: 'fakturaformedlare.BENAMNING',
        caption: 'Fakturaförmedlare',
      },
    ],
  },
}));

export default KRBusinessConfig;
